export var PlayerFeedbackStatusType;
(function (PlayerFeedbackStatusType) {
    PlayerFeedbackStatusType["EXPIRED"] = "expired";
    PlayerFeedbackStatusType["RECEIVED"] = "received";
    PlayerFeedbackStatusType["PENDING"] = "pending";
    PlayerFeedbackStatusType["PROCESSING"] = "processing";
})(PlayerFeedbackStatusType || (PlayerFeedbackStatusType = {}));
//# sourceMappingURL=PlayerFeedbackStatusType.js.map